import { TreeGridTranslations } from "../../hooks/use-translations"

type ToolbarConfig = Record<string, string | number>

const makeToolbarBase = (): ToolbarConfig => ({
  AddChild: 0,
  Cfg: 0,
  Contrasts: 0,
  Debug: 0,
  DefSort: 0,
  GanttStyles: 0,
  Help: 0,
  Indent: 0,
  Lock: 0,
  Outdent: 0,
  Reload: 0,
  Sizes: 0,
  Space: 0,
  Styles: 0,
  WinScroll: 0,
  Correct: 0,
  Add: 0,
  Link: 0,
  Calc: 0,
})

const makeToolbarSearch = (translations: TreeGridTranslations): ToolbarConfig => ({
  SearchLabel: translations.toolbarSearchInputLabel,
  SearchTip: translations.toolbarSearchInputTip,
  SearchType: "Text",
  SearchCanEdit: 1,
  SearchWidth: 200,
  SearchOnClick: "Focus AND StartEdit",
  SearchOnChange: "window.Grids.OnSearchChange(Grid, Value)",
})

const makeToolbarSummary = (summary: string): ToolbarConfig => ({
  SummaryType: "Html",
  SummaryCanEdit: 0,
  Summary: summary,
})

const makeToolbarFilter = (isFilterActive: boolean): ToolbarConfig => ({
  Cells60Filter: "Filter",
  FilterType: "Button",
  FilterButtonClass: isFilterActive ? "Filter_Button_Active" : "Filter_Button",
  FilterOnClick: "window.Grids.OnFilterToggle()",
})

const makeToolbarGanttZoom = ({
  showGanttToolbarActions,
  translations,
}: {
  showGanttToolbarActions: boolean
  translations: TreeGridTranslations
}): ToolbarConfig => ({
  Cells50GanttZoom: "",
  Cells80Right: "Spacer",
  SpacerHtml: "<span></span>",
  SpacerRelWidth: "1",
  Cells99GanttZoom: showGanttToolbarActions ? "ZoomIn,ZoomOut,ZoomFit,Zoom" : "",
  ZoomType: "SelectGanttZoom",
  ZoomHtmlPrefix: `${translations.showLabel} <b>`,
  ZoomHtmlPostfix: "</b>",
  ZoomWidth: "184",
})

const makeToolbarTips = (translations: TreeGridTranslations): ToolbarConfig => ({
  PrintTip: translations.toolbarPrintTip,
  ExportTip: translations.toolbarExportTip,
  ExpandAllTip: translations.toolbarExpandAllTip,
  CollapseAllTip: translations.toolbarCollapseAllTip,
  ColumnsTip: translations.toolbarColumnsTip,
  FilterTip: translations.toolbarFilterTip,
  ScalesLabel: translations.scaleLabel,
})

const makeToolbarZoomTips = (translations: TreeGridTranslations): ToolbarConfig => ({
  ZoomInTip: translations.toolbarZoomInTip,
  ZoomOutTip: translations.toolbarZoomOutTip,
  ZoomFitTip: translations.toolbarZoomFitTip,
})

export class ToolbarBuilder {
  private toolbar: ToolbarConfig = makeToolbarBase()

  addCustomToolbarConfig(config: ToolbarConfig): this {
    this.toolbar = { ...this.toolbar, ...config }
    return this
  }

  addToolbarSearch(translations: TreeGridTranslations): this {
    return this.addCustomToolbarConfig(makeToolbarSearch(translations))
  }

  addToolbarSummary(summary: string): this {
    return this.addCustomToolbarConfig(makeToolbarSummary(summary))
  }

  addToolbarFilter(isFilterActive: boolean): this {
    return this.addCustomToolbarConfig(makeToolbarFilter(isFilterActive))
  }

  addToolbarGanttZoom(props: { showGanttToolbarActions: boolean; translations: TreeGridTranslations }): this {
    return this.addCustomToolbarConfig(makeToolbarGanttZoom(props))
  }

  addToolbarTips(translations: TreeGridTranslations): this {
    return this.addCustomToolbarConfig(makeToolbarTips(translations))
  }

  addToolbarZoomTips(translations: TreeGridTranslations): this {
    return this.addCustomToolbarConfig(makeToolbarZoomTips(translations))
  }

  build(): ToolbarConfig {
    return this.toolbar
  }
}
